import { createSlice } from '@reduxjs/toolkit';
import { Ticket } from './Ticket';
import { ticketEasyApi } from '../../ticketEasy-api';

interface TicketEasyState {
  tickets: Ticket[];
}

const initialState: TicketEasyState = {
  tickets: [],
};

const ticketEasySlice = createSlice({
  name: 'ticketEasy',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        ticketEasyApi.endpoints.ticketSearch.matchFulfilled,
        (state, { payload }) => {
          state.tickets = payload;
        }
      )
      .addMatcher(
        ticketEasyApi.endpoints.ticketCreate.matchFulfilled,
        (state, { payload }) => {
          state.tickets.push(payload);
        }
      )
  },
});

export const {
} = ticketEasySlice.actions;

export default ticketEasySlice.reducer;